import { render } from "./aBtn.vue?vue&type=template&id=343f8371"
import script from "./aBtn.vue?vue&type=script&lang=js"
export * from "./aBtn.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__